// extracted by mini-css-extract-plugin
export default {"container":"RailHeader_container__6GHgN","titleContainer":"RailHeader_titleContainer__bdK-A"};